import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import apihost from "../../services/apihostname";

//Import module Modal
import Modal from "react-bootstrap/Modal";

//import crop
import ModalCrop from "./ModalCrop";

// Import module Services
import TambonService from "../../services/tambon.service";
import farmerService from "../../services/farmer.service";
import authService from "../../services/auth.service";
import externalService from "../../services/external.service";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import module for datePicker
import dayjs from "dayjs";
import { WatDatePicker } from "thaidatepicker-react";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

//Import loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

//Import WebCam
import Webcam from "./Webcam";

//Import farmer.css
import "./farmer.css";

const valid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0.75rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
};

const invalid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0 0.375rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #dc3545",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  paddingRight: "calc(1.5em + 0.75rem)",
  backgroundImage:
    'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right calc(0.375em + 0.1875rem) center",
  backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
};

function ModaleditFarmer(props) {
  const [hiddenCamera, setHiddenCamera] = useState(true);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [prov, setProv] = useState([]);
  // const [proselect, setProselect] = useState("0");
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [hiddenprename, setHiddenprename] = useState(true);
  const [amp, setAmp] = useState([]);
  const [tam, setTam] = useState([]);
  const [showCrop, setShowCrop] = useState(false);

  const [selectedDate, setSelectedDate] = useState("");
  // const [selectedThaiDate, setSelectedThaiDate] = useState("");
  // console.log(showCroppedImage);

  const user = authService.getCurrentUser();

  const handleWatDatePickerChange = (christDate, buddhistDate) => {
    console.log(buddhistDate);
    setSelectedDate(christDate);
    // Check click remove date
    if (christDate) {
      setForm({
        ...form,
        ["birth_date"]: christDate,
      });
    } else {
      setForm({
        ...form,
        ["birth_date"]: "",
      });
    }
    //Set error to Null
    setErrors({
      ...errors,
      ["birth_date"]: null,
    });
  };

  // const user = JSON.parse(sessionStorage.getItem("user"));
  const handleClose = () => {
    // initialForm();

    setErrors({});
    setHiddenCamera(true);
    props.hidden(false);
  };
  const getProv = () => {
    return Promise.resolve(
      TambonService.get({ pro_id: "0", amp_id: "0", tam_id: "0" })
        .then((response) => {
          setProv(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching Prove: ", error);
        })
    );
  };
  useEffect(() => {
    getProv();
  }, []);

  useEffect(() => {
    if (props.farmer_id != 0) {
      setForm({});
      farmerService.getFarmerById(props.farmer_id).then((data) => {
        // console.log(data);
        if (data.data.success) {
          setSelectedDate("clear");
          setSelectedDate(data.data.farmer.birth_date);
          const status = data.data.farmer.status ? "มีชีวิต" : "เสียชีวิต";
          let prename = "";
          let preother = "";
          let cwt = 0;
          let amp = 0;
          let tam = 0;
          if (
            data.data.farmer.pre_name == "นาย" ||
            data.data.farmer.pre_name == "นาง" ||
            data.data.farmer.pre_name == "น.ส."
          ) {
            // setForm({
            //   ...form,
            //   ["pre_name"]: data.data.farmer.pre_name,
            // });
            prename = data.data.farmer.pre_name;
            setHiddenprename(true);
          } else {
            // setForm({
            //   ...form,
            //   ["pre_name"]: "อื่นๆ",
            //   ["pre_other"]: data.data.farmer.pre_name,
            // });
            prename = "อื่นๆ";
            preother = data.data.farmer.pre_name;
            setHiddenprename(false);
          }
          setImage({
            preview:
              data.data.farmer.farmer_image &&
              data.data.farmer.farmer_image != ""
                ? apihost + "/images/farmer/" + data.data.farmer.farmer_image
                : "",
          });

          // setForm({
          //   ...form,
          //   ["id_card"]: data.data.farmer.id_card,
          //   ["sex"]: data.data.farmer.sex,
          //   ["first_name"]: data.data.farmer.first_name,
          //   ["last_name"]: data.data.farmer.last_name,
          //   ["address"]: data.data.farmer.address,
          //   ["birth_date"]: data.data.farmer.birth_date,
          //   ["tel"]: data.data.farmer.tel,
          //   ["status"]: status,
          // });
          // if (
          //   data.data.farmer.pre_name == "นาย" ||
          //   data.data.farmer.pre_name == "นาง" ||
          //   data.data.farmer.pre_name == "น.ส."
          // ) {
          //   setForm({
          //     ...form,
          //     ["pre_name"]: data.data.farmer.pre_name,
          //   });
          //   setHiddenprename(true);
          // } else {
          //   setForm({
          //     ...form,
          //     ["pre_name"]: "อื่นๆ",
          //     ["pre_other"]: data.data.farmer.pre_name,
          //   });
          //   setHiddenprename(false);
          // }
          TambonService.getByname({
            prov_name: data.data.farmer.prov_namt,
            amp_name: data.data.farmer.amp_namt,
            tam_name: data.data.farmer.tam_namt,
          }).then((response) => {
            // console.log(response.data);
            // setForm({
            //   ...form,
            //   ["prov"]: response.data.data.cwt,
            // });
            cwt = response.data.data.cwt;
            amp = response.data.data.amp;
            tam = response.data.data.tambon;

            setAmp([
              {
                value: response.data.data.amp,
                label: response.data.data.amp_namt,
              },
            ]);
            setTam([
              {
                value: response.data.data.tambon,
                label: response.data.data.tam_namt,
              },
            ]);
            setForm({
              ...data.data.farmer,
              ["status"]: status,
              ["pre_name"]: prename,
              ["pre_other"]: preother,
              ["prov"]: cwt,
              ["amp"]: amp,
              ["tam"]: tam,
            });

            // setForm({
            //   ...form,
            //   ["amp"]: response.data.data.amp,
            //   ["tam"]: response.data.data.tambon,
            // });
          });

          // const new_prov = prov.filter(
          //   (o) => o.label == response.data.prov.replace("จังหวัด", "")
          // );
        } else {
          alert(data.data.message);
        }
      });
    }
  }, [props.farmer_id]);

  const getAmp = (prov) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching amp: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getAmp(form.prov);
  // }, [form.prov]);

  const handleProvChange = async (prov) => {
    setErrors({
      ...errors,
      ["prov"]: null,
    });
    if (prov && prov != "") {
      await getAmp(prov).then((response) => {
        setAmp(response.data.data);
        setForm({
          ...form,
          ["prov"]: prov,
          ["amp"]: "",
          ["tam"]: "",
        });
      });
    } else {
      setAmp([]);
      setTam([]);
      setForm({
        ...form,
        ["amp"]: "",
        ["tam"]: "",
      });
    }
  };

  const getTam = (prov, amp) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: amp ? amp : 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching tam: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getTam(form.prov, form.amp);
  // }, [form.amp]);

  const handleAmpChange = async (prov, amp) => {
    setErrors({
      ...errors,
      ["amp"]: null,
    });
    if (amp && amp != "") {
      await getTam(prov, amp).then((response) => {
        setTam(response.data.data);
        setForm({
          ...form,
          ["amp"]: amp,
          ["tam"]: "",
        });
      });
    } else {
      setTam([]);
      setForm({
        ...form,
        ["tam"]: "",
      });
    }
  };

  function checkID(id) {
    console.log(id.length);
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  }

  const initialForm = () => {
    setSelectedDate("");
    setHiddenprename(true);
    setForm({});
    setErrors({});
  };
  const setField = (field, value) => {
    if (field.name == "pre_name" && value == "อื่นๆ") {
      setHiddenprename(false);
    } else if (field.name == "pre_name" && value !== "อื่นๆ") {
      setHiddenprename(true);
    }
    if (field.name == "id_card") {
      console.log(!checkID(value));
      if (value.length != 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขบัตรไม่ครบ" });
      } else if (!checkID(value)) {
        setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
      } else {
        setErrors({ ...errors, [field.name]: null });
      }
    }

    if (field.files) {
      console.log(field.name + "-" + field.files[0]);
      setShowCrop(true);
      setImage({
        preview: URL.createObjectURL(field.files[0]),
      });
      setForm({
        ...form,
        [field.name]: field.files[0],
      });
      console.log(form);
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name] && field.name != "id_card")
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };

  const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  const findFormErrors = () => {
    console.log(form);
    const {
      id_card,
      pre_name,
      pre_other,
      first_name,
      last_name,
      prov,
      amp,
      tam,
      sex,
      birth_date,
    } = form;
    const newErrors = {};

    // check card error
    if (!id_card || id_card === "") newErrors.id_card = "กรุณากรอกบัตรประชาชน";
    // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // prename errors
    if (!pre_name || pre_name === "0") {
      newErrors.pre_name = "กรุณาเลือกคำนำหน้า";
    } else if (pre_name === "อื่นๆ" && (pre_other === "" || !pre_other)) {
      newErrors.pre_other = "กรุณากรอกคำนำหน้า";
    }

    // firstname
    if (!first_name || first_name === "")
      newErrors.first_name = "กรุณากรอกชื่อ";

    // lastname
    if (!last_name || last_name === "") newErrors.last_name = "กรุณากรอกนาสกุล";

    // province
    if (!prov || prov === "") newErrors.prov = "กรุณาเลือกจังหวัด";

    // amphoe
    if (!amp || amp === "") newErrors.amp = "กรุณาเลือกอำเภอ";

    // tam
    if (!tam || tam === "") newErrors.tam = "กรุณาเลือกตำบล";

    // sex
    if (!sex || sex === "") newErrors.sex = "กรุณาเลือกตำบล";

    // birthday
    console.log(!birth_date);
    console.log(birth_date);
    if (!birth_date || birth_date === "")
      newErrors.birth_date = "กรุณากรอกวันเกิด";

    return newErrors;
  };
  const handleClickGetPerson = (e) => {
    e.preventDefault();
    const genderText = ["ชาย", "หญิง"];
    const id_card = form.id_card;
    initialForm();
    setForm((a) => ({ ...a, id_card: id_card }));

    if (form.id_card && checkID(form.id_card)) {
      setLoading(true);
      externalService
        .getPersonal({ citizenId: form.id_card, user_id: user.user.user_id })
        .then(async (response) => {
          // alert(JSON.stringify(response.data));
          if (response.data.dateOfBirth && response.data.houseID) {
            const checkDate = isValidDate(
              new Date(
                (
                  parseInt(response.data.dateOfBirth.toString().slice(0, 4)) -
                  543
                ).toString() +
                  "-" +
                  response.data.dateOfBirth.toString().slice(4, 6) +
                  "-" +
                  response.data.dateOfBirth.toString().slice(6, 8)
              )
            );
            if (checkDate) {
              setSelectedDate("clear");
              setSelectedDate(
                (
                  parseInt(response.data.dateOfBirth.toString().slice(0, 4)) -
                  543
                ).toString() +
                  "-" +
                  response.data.dateOfBirth.toString().slice(4, 6) +
                  "-" +
                  response.data.dateOfBirth.toString().slice(6, 8)
              );
            } else {
              toast.error(
                "วันเกิดไม่ถูกต้อง->" + response.data.dateOfBirth.toString()
              );
            }

            const setValue = (res, callback) => {
              if (
                res.data.titleDesc == "นาย" ||
                res.data.titleDesc == "นาง" ||
                res.data.titleDesc == "น.ส."
              ) {
                setForm({
                  ...form,
                  ["pre_name"]: res.data.titleDesc,
                });
                setHiddenprename(true);
              } else {
                setForm({
                  ...form,
                  ["pre_name"]: "อื่นๆ",
                  ["pre_other"]: res.data.titleDesc,
                });
                setHiddenprename(false);
              }
              setForm((newform) => ({
                ...newform,
                // ["id_card"]: res.data.data.citizenID,
                ["sex"]: genderText[parseInt(res.data.genderCode) - 1],
                ["first_name"]: res.data.firstName,
                ["last_name"]: res.data.lastName,
                ["address"]: res.data.houseNo
                  ? res.data.houseNo
                  : "" + " " + res.data.alleyWayDesc
                  ? res.data.alleyWayDesc
                  : "" + " " + res.data.alleyDesc
                  ? res.data.alleyDesc
                  : "" + " " + res.data.roadDesc
                  ? res.data.roadDesc
                  : "",
                ["birth_date"]: checkDate
                  ? (
                      parseInt(res.data.dateOfBirth.toString().slice(0, 4)) -
                      543
                    ).toString() +
                    "-" +
                    res.data.dateOfBirth.toString().slice(4, 6) +
                    "-" +
                    res.data.dateOfBirth.toString().slice(6, 8)
                  : "",
              }));
              return callback(res);
            };

            const setLocaton = (res) => {
              const new_prov = prov.filter(
                (o) => o.label == res.data.provinceDesc.replace("จังหวัด", "")
              );
              console.log(new_prov);
              setForm((newform) => ({
                ...newform,
                ["prov"]: new_prov[0].value,
              }));
              TambonService.getByname({
                prov_name: res.data.provinceDesc.replace("จังหวัด", ""),
                amp_name:
                  res.data.provinceDesc.replace("จังหวัด", "") ==
                  "กรุงเทพมหานคร"
                    ? res.data.districtDesc.replace("เขต", "")
                    : res.data.districtDesc.replace("อำเภอ", ""),
                tam_name:
                  res.data.provinceDesc.replace("จังหวัด", "") ==
                  "กรุงเทพมหานคร"
                    ? res.data.subdistrictDesc.replace("แขวง", "")
                    : res.data.subdistrictDesc.replace("ตำบล", ""),
              })
                .then((responseTam) => {
                  // console.log(response.data);
                  const setListAmpTam = (result, callback) => {
                    setAmp([
                      {
                        value: result.data.data.amp,
                        label: result.data.data.amp_namt,
                      },
                    ]);
                    setTam([
                      {
                        value: result.data.data.tambon,
                        label: result.data.data.tam_namt,
                      },
                    ]);
                    return callback(result);
                  };
                  setListAmpTam(responseTam, (a) => {
                    console.log(a);
                    setForm((newform) => ({
                      ...newform,
                      ["amp"]: a.data.data.amp,
                      ["tam"]: a.data.data.tambon,
                    }));
                    // setLoading(false);
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            };

            setValue(response, setLocaton);
          } else {
            confirmAlert({
              title: "",
              message: "ดึงข้อมูลจากทะเบียนราษฎร์ไม่ได้",
              buttons: [
                {
                  label: "ปิด",
                  onClick: () => false,
                },
              ],
              overlayClassName: "confirm-alert confirm-alert-onebutton",
            });
          }
        })
        .catch((error) => {
          toast.error("error fetch data: " + error);
        })
        .finally(() => setLoading(false));
    } else {
      toast.error("เลขบัตรประชาชนไม่ถูกต้อง");
    }
  };
  const handleClickReadCard = () => {
    const genderText = ["ชาย", "หญิง"];
    initialForm();
    setLoading(true);
    farmerService
      .readCard()
      .then(async (response) => {
        if (response.data.status === "active") {
          const checkDate = isValidDate(
            new Date(
              (parseInt(response.data.dob.slice(0, 4)) - 543).toString() +
                "-" +
                response.data.dob.slice(4, 6) +
                "-" +
                response.data.dob.slice(6, 8)
            )
          );
          if (checkDate) {
            setSelectedDate("clear");
            setSelectedDate(
              (parseInt(response.data.dob.slice(0, 4)) - 543).toString() +
                "-" +
                response.data.dob.slice(4, 6) +
                "-" +
                response.data.dob.slice(6, 8)
            );
          } else {
            toast.error("วันเกิดไม่ถูกต้อง");
          }

          const setValue = (res, callback) => {
            if (
              res.data.title == "นาย" ||
              res.data.title == "นาง" ||
              res.data.title == "น.ส."
            ) {
              setForm({
                ...form,
                ["pre_name"]: res.data.title,
              });
              setHiddenprename(true);
            } else {
              setForm({
                ...form,
                ["pre_name"]: "อื่นๆ",
                ["pre_other"]: res.data.title,
              });
              setHiddenprename(false);
            }
            setForm((newform) => ({
              ...newform,
              ["id_card"]: res.data.idnumber,
              ["sex"]: genderText[parseInt(res.data.gender) - 1],
              ["first_name"]: res.data.firstname,
              ["last_name"]: res.data.lastname,
              ["address"]: res.data.address1,
              ["birth_date"]: checkDate
                ? (parseInt(res.data.dob.slice(0, 4)) - 543).toString() +
                  "-" +
                  res.data.dob.slice(4, 6) +
                  "-" +
                  res.data.dob.slice(6, 8)
                : "",
            }));
            return callback(res);
          };

          const setLocaton = (res) => {
            const new_prov = prov.filter(
              (o) => o.label == res.data.prov.replace("จังหวัด", "")
            );
            console.log(new_prov);
            setForm((newform) => ({
              ...newform,
              ["prov"]: new_prov[0].value,
            }));
            TambonService.getByname({
              prov_name: res.data.prov.replace("จังหวัด", ""),
              amp_name:
                res.data.prov.replace("จังหวัด", "") == "กรุงเทพมหานคร"
                  ? res.data.amp.replace("เขต", "")
                  : res.data.amp.replace("อำเภอ", ""),
              tam_name:
                res.data.prov.replace("จังหวัด", "") == "กรุงเทพมหานคร"
                  ? res.data.tam.replace("แขวง", "")
                  : res.data.tam.replace("ตำบล", ""),
            }).then((responseTam) => {
              // console.log(response.data);
              const setListAmpTam = (result, callback) => {
                setAmp([
                  {
                    value: result.data.data.amp,
                    label: result.data.data.amp_namt,
                  },
                ]);
                setTam([
                  {
                    value: result.data.data.tambon,
                    label: result.data.data.tam_namt,
                  },
                ]);
                return callback(result);
              };
              setListAmpTam(responseTam, (a) => {
                console.log(a);
                setForm((newform) => ({
                  ...newform,
                  ["amp"]: a.data.data.amp,
                  ["tam"]: a.data.data.tambon,
                }));
                farmerService.getPhotoByCard().then(async (responseImg) => {
                  var imgsrc =
                    "data:image/png;base64," +
                    btoa(
                      String.fromCharCode.apply(
                        null,
                        new Uint8Array(responseImg.data.photo)
                      )
                    );
                  const blob = await fetch(imgsrc).then((resimg) =>
                    resimg.blob()
                  );
                  setForm((newform) => ({
                    ...newform,
                    ["farmerProfileImg"]: blob,
                  }));
                  setImage({
                    preview: URL.createObjectURL(blob),
                  });
                  setLoading(false);
                  setShowCrop(true);
                });
              });
            });
          };

          setValue(response, setLocaton);
        } else {
          confirmAlert({
            title: "",
            message: "อ่านบัตรประชาชนไม่ได้",
            buttons: [
              {
                label: "ปิด",
                onClick: () => false,
              },
            ],
            overlayClassName: "confirm-alert confirm-alert-onebutton",
          });
        }
      })
      .catch((error) => {
        toast.error(error + " - กรุณาตรวจสอบการเปิดโปรแกรม");
      })
      .finally(() => setLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setLoading(true);
      form.user_id = user.user.user_id;
      const data = new FormData();
      for (const key in form) {
        data.append(key, form[key]);
      }
      console.log(data);
      farmerService
        .updateFarmerById(data)
        .then((response) => {
          if (response.data.success) {
            console.log(response.data);
            var newArray = props.data.map(function (el) {
              if (el.farmer_id != props.farmer_id) {
                return el;
              } else {
                var check = response.data.data;
                return check;
              }
            });

            props.setdata([...newArray]);
          } else {
            alert(response.data.message);
          }
        })
        .catch((error) => {
          alert(error);
          console.log(error);
        })
        .finally(() => {
          console.log(false);
          props.hidden(false);
          setLoading(false);
        });
    }
  };
  const urlImage = (e) => {
    console.log(e);
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e,
    }));
    setImage({
      preview: URL.createObjectURL(e),
    });
    setShowCrop(true);
  };
  const cropImage = (e) => {
    console.log(e);
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e.file,
    }));
    setImage({
      preview: e.preview,
    });
  };
  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <ModalCrop
        show={showCrop}
        hidden={setShowCrop}
        image={image.preview}
        setCrop={cropImage}
      />
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขข้อมูล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="uploadpic">
            <label htmlFor="upload-button">
              {image.preview && image.preview != "" ? (
                <img
                  src={image.preview}
                  alt="No Image"
                  width="150"
                  height="150"
                />
              ) : (
                <>
                  <span className="fa-stack fa-2x mt-3 mb-2">
                    <i className="fas fa-circle fa-stack-2x" />
                    <i className="fas fa-store fa-stack-1x fa-inverse" />
                  </span>
                  <h5 className="text-center">Upload your photo</h5>
                </>
              )}
            </label>
            <input
              type="file"
              id="upload-button"
              name="farmerProfileImg"
              style={{ display: "none" }}
              onChange={(e) => setField(e.target, e.target.value)}
            />
            <br />
            {/* <Button variant="primary" type="button" onClick={handleUpload}>
            อัพโหลด
          </Button> */}
          </div>
          <div style={{ textAlign: "center" }}>
            <br />
            {hiddenCamera ? "" : <Webcam urlImage={urlImage} />}
            <button
              className="btn btn-primary"
              onClick={() =>
                hiddenCamera ? setHiddenCamera(false) : setHiddenCamera(true)
              }
              style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
            >
              {hiddenCamera ? "เปิดกล้อง" : "ปิดกล้อง"}
            </button>
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              className="btn btn-primary"
              onClick={handleClickReadCard}
              style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
            >
              คลิ๊กอ่านบัตร
            </button>
          </div>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>หมายเลขบัตรประชาชน</Form.Label>
                  <FormControl
                    placeholder="หมายเลขบัตรประชาชน"
                    type="number"
                    name="id_card"
                    value={form.id_card || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.id_card}
                    disabled={true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.id_card}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="2" className="col-custom">
                <button
                  className="btn btn-primary"
                  onClick={handleClickGetPerson}
                  style={{ padding: ".375rem .75rem", fontSize: "0.8rem" }}
                >
                  ทะเบียนราษฏร์
                </button>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>คำนำหน้า</Form.Label>
                  <Form.Select
                    name="pre_name"
                    value={form.pre_name || "0"}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_name}
                  >
                    <option value="0">เลือก...</option>
                    <option value="นาย">นาย</option>
                    <option value="นาง">นาง</option>
                    <option value="น.ส.">น.ส.</option>
                    <option value="อื่นๆ">อื่นๆ</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row hidden={hiddenprename}>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อื่นๆ </Form.Label>
                  <FormControl
                    placeholder="คำนำหน้าอื่น ๆ"
                    type="text"
                    name="pre_other"
                    value={form.pre_other || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_other}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_other}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6"></Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อ"
                    type="text"
                    name="first_name"
                    value={form.first_name || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.first_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.first_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>นามสกุล</Form.Label>
                  <FormControl
                    placeholder="นามสกุล"
                    type="text"
                    name="last_name"
                    value={form.last_name || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.last_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.last_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>เพศ</Form.Label>
                  <Form.Select
                    name="sex"
                    value={form.sex || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.sex}
                  >
                    <option value="">เลือก...</option>
                    <option value="ชาย">ชาย</option>
                    <option value="หญิง">หญิง</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.sex}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โทร.</Form.Label>
                  <FormControl
                    placeholder="โทร"
                    type="text"
                    name="tel"
                    value={form.tel || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tel}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tel}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>{!!errors.birth_date}วันที่เกิด</Form.Label>
                  {/* <FormControl
                    placeholder="Birth Day"
                    type="date"
                    name="birth_date"
                    value={form.birth_date}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.birth_date}
                  /> */}
                  {selectedDate == "" || selectedDate != "clear" ? (
                    <WatDatePicker
                      placeholder="กรอกวันเกิด"
                      value={selectedDate || ""} // Can be replace with string or dayjs object (e.g. "2020-12-31" or `dayjs()`)
                      onChange={handleWatDatePickerChange}
                      dateFormat={"yyyy-MM-dd"} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
                      displayFormat={"DD MMMM YYYY"} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
                      inputStyle={errors.birth_date ? invalid : valid} // styles for input
                      clearable={true} // true | false
                      // minDate={"2020-12-26"} // supported date as string
                      maxDate={dayjs().add(20, "day")} // also supported dayjs or moment
                      disabled={false} // true | false
                      readOnly={false} // true | false
                      yearBoundary={99} // number of boundary ±X Year
                    />
                  ) : (
                    ""
                  )}

                  <div
                    className={
                      errors.birth_date
                        ? "custom-valid-feedback"
                        : "custom-invalid-feedback"
                    }
                  >
                    {errors.birth_date}
                  </div>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ที่อยู่</Form.Label>
                  <FormControl
                    placeholder="ที่อยู่"
                    type="text"
                    name="address"
                    value={form.address || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.address}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.address}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>จังหวัด</Form.Label>
                  <Form.Select
                    name="prov"
                    value={form.prov || ""}
                    onChange={(e) => handleProvChange(e.target.value)}
                    isInvalid={!!errors.prov}
                  >
                    <option value="">เลือกจังหวัด</option>
                    {prov.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.prov}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อำเภอ</Form.Label>
                  <Form.Select
                    name="amp"
                    value={form.amp || ""}
                    onChange={(e) => handleAmpChange(form.prov, e.target.value)}
                    isInvalid={!!errors.amp}
                  >
                    <option value="">เลือกอำเภอ</option>
                    {amp.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.amp}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำบล</Form.Label>
                  <Form.Select
                    name="tam"
                    value={form.tam || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tam}
                  >
                    <option value="">เลือกตำบล</option>
                    {tam.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.tam}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>สถานะการมีชีวิต</Form.Label>
                  <FormControl
                    placeholder="สถานะการมีชีวิต"
                    type="text"
                    name="status"
                    value={form.status || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.status}
                    disabled={true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.status}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            ตกลง
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModaleditFarmer;

ModaleditFarmer.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
  farmer_id: PropTypes.number,
};
ModaleditFarmer.defaultProps = {
  data: [],
};
